import type { GovMessageProps } from '@gov-design-system-ce/react';
import { GovMessage } from '@gov-design-system-ce/react';
import { Icon } from '../Icon';

interface MessageProps extends GovMessageProps {}

const MessageIcon = ({ color }: Pick<GovMessageProps, 'color'>) => {
	if (color === 'error') {
		return (
			<Icon
				type="components"
				name="exclamation-triangle-fill"
				slot="icon"
			/>
		);
	}

	return null;
};

export const Message = (props: MessageProps) => (
	<GovMessage
		icon={props.icon === undefined ? <MessageIcon color={props.color} /> : null}
		type="subtle"
		{...props}
	/>
);
